import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutStats, testimonials } from '@/mocks/articles';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51爆料网',
    url: 'https://eeeeme.cn',
    description: '51爆料网是实时追踪网红黑料与吃瓜爆料的专业平台，每日更新娱乐八卦、网红爆料、明星动态等热门内容。',
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51爆料网',
    description: '51爆料网品牌介绍、平台实力展示、用户口碑评价及联系方式。',
    url: 'https://eeeeme.cn/about',
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51爆料网的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51爆料网拥有专业的编辑团队和多方信息渠道，所有爆料内容均经过严格核实后方可发布。我们坚持事实报道原则，为读者提供真实可靠的娱乐资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系51爆料网进行合作或爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站底部的联系方式与我们取得联系，或发送邮件至官方邮箱。我们欢迎各类合作洽谈和线索提供。',
        },
      },
      {
        '@type': 'Question',
        name: '51爆料网APP有哪些功能？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51爆料网APP支持实时推送最新爆料、个性化分类订阅、离线阅读、夜间模式、互动评论等功能，为吃瓜群众提供极致的浏览体验。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="px-4 md:px-6 lg:px-8 py-4">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <section className="py-10 md:py-14 px-4 md:px-6 lg:px-8">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
              关于51爆料网
            </h1>
            <p className="text-sm text-foreground-500 max-w-2xl">
              实时追踪网红黑料与吃瓜爆料的专业平台，每日更新，黑料不打烊
            </p>
          </section>

          <section className="flex flex-col lg:flex-row">
            <div className="lg:w-3/5 px-4 md:px-6 lg:px-8 py-10 md:py-14">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                做最真实的爆料平台
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                51爆料网成立于2023年，由一群热爱娱乐八卦、追求真相的媒体人共同创办。我们致力于为广大吃瓜群众提供第一手、高质量的娱乐爆料资讯。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                在这个信息爆炸的时代，真假消息混杂，而我们始终坚持事实核查和多方求证的原则，确保每一条爆料都经过严格审核。我们的编辑团队由资深娱乐记者、数据分析师和内容创作者组成，24小时轮班值守，确保不错过任何一个热点。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-8">
                从网红翻车到明星塌房，从选秀黑幕到行业潜规则，51爆料网始终站在吃瓜第一线，为用户还原事件真相。
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {aboutStats.map((stat) => (
                  <div key={stat.label} className="text-center p-4 rounded-lg border border-background-200/70">
                    <p className="text-xl md:text-2xl font-black text-accent-500">
                      {stat.value}{stat.suffix}
                    </p>
                    <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:w-2/5 relative min-h-[300px] lg:min-h-[500px] bg-accent-50/30 overflow-hidden">
              <div className="absolute inset-0 flex items-center justify-center p-8">
                <div className="grid grid-cols-2 gap-4 opacity-40">
                  <div className="w-24 h-32 rounded-2xl bg-accent-200/60"></div>
                  <div className="w-20 h-20 rounded-full bg-accent-300/50 mt-8"></div>
                  <div className="w-16 h-24 rounded-xl bg-accent-100/70 -mt-4"></div>
                  <div className="w-28 h-16 rounded-3xl bg-accent-200/50 -mt-10"></div>
                </div>
              </div>
              <div className="absolute bottom-8 left-8 right-8">
                <p className="text-sm text-accent-700 font-medium">我们的使命</p>
                <p className="text-xs text-accent-500 mt-1">让每一个吃瓜群众都能第一时间掌握真实爆料</p>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-16 px-4 md:px-6 lg:px-8 bg-background-100/50">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">
              网友真实评价
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="p-6 rounded-lg bg-background-50 border border-background-200/70 flex flex-col"
                >
                  <div className="flex-1">
                    <span className="inline-block text-3xl text-accent-300 leading-none mb-2">&ldquo;</span>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {testimonial.content}
                    </p>
                  </div>
                  <div className="mt-4 pt-4 border-t border-background-100 flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-950">{testimonial.name}</span>
                    {testimonial.verified && (
                      <span className="inline-flex items-center gap-1 text-xs text-accent-500">
                        <i className="ri-verified-badge-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                        已认证
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="contact" className="py-14 md:py-16 px-4 md:px-6 lg:px-8">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">business@51baoliao.com</p>
              </div>
              <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-chat-1-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">线索爆料</h3>
                <p className="text-xs text-foreground-500">tips@51baoliao.com</p>
              </div>
              <div className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mb-3">
                  <i className="ri-customer-service-line text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">用户反馈</h3>
                <p className="text-xs text-foreground-500">feedback@51baoliao.com</p>
              </div>
            </div>

            <div className="mt-10 max-w-lg mx-auto text-center">
              <p className="text-xs text-foreground-400 mb-3">关注我们的社交媒体</p>
              <div className="flex items-center justify-center gap-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line text-lg w-5 h-5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </section>

          <section className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 relative h-[360px] lg:h-[500px] overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20news%20app%20interface%20warm%20red%20accent%20on%20cream%20background%20soft%20lighting%20clean%20composition%20product%20photography%20editorial%20elegant&width=1200&height=800&seq=about-cta-left-02&orientation=portrait"
                alt="51爆料网APP"
                title="51爆料网APP下载"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <p className="text-xs text-background-200 uppercase tracking-wider mb-1">51爆料网 APP</p>
                <h2 className="text-3xl md:text-4xl font-black text-background-50 leading-none">加入我们</h2>
                <h2 className="text-3xl md:text-4xl font-black text-background-50 leading-none">一起吃瓜</h2>
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center">
                下载51爆料网APP
              </h2>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mt-1">
                黑料实时推送不遗漏
              </h3>
              <p className="text-sm text-foreground-500 text-center mt-6 max-w-md leading-relaxed">
                支持iOS和Android双平台下载，安装后开启推送通知，第一时间获取最新爆料。更有专属APP用户福利等你来领。
              </p>
              <div className="mt-8 flex items-center gap-4 flex-wrap justify-center">
                <a
                  href="#"
                  className="flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">App Store 下载</span>
                </a>
                <a
                  href="#"
                  className="flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">Android 下载</span>
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}